import script from "./UserNote.vue?vue&type=script&setup=true&lang=js"
export * from "./UserNote.vue?vue&type=script&setup=true&lang=js"

import "./UserNote.vue?vue&type=style&index=0&id=1585558b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1585558b"]])

export default __exports__